module.exports = flarum.core.compat['components/SettingsPage'];